import { Column } from '@ydistri/ds';
import React, { useEffect, useMemo } from 'react';
import useResetImport from '../../common/useResetImport';
import { useTemplateOrCalculation } from '../../../../../../../../hooks/useTemplateOrCalculation';
import { useGetCalculationQuery } from '../../../../../../apiCalculationDetail';
import { CalculationStatus } from '@ydistri/api-sdk';
import { useAppDispatch } from '../../../../../../../../store';
import SkuRedistributionRunningMessage from '../../../../listing/components/SkuRedistributionRunningMessage/SkuRedistributionRunningMessage';
import { addToast } from '@ydistri/utils';

/**
 * Display information that import is in progress. Once the import is finished,
 * automatically reset the import state, which will result in switching to the redistribution table
 * and show a success message.
 */
const RedistributionImportStepFinalized: React.FC = () => {
  const dispatch = useAppDispatch();
  const resetImport = useResetImport();

  const calculation = useTemplateOrCalculation();
  const { data, isFetching } = useGetCalculationQuery(calculation.id);

  const isPending = useMemo(() => {
    if (isFetching) return true;

    if (data?.status === CalculationStatus.Completed) {
      return false;
    }

    return true;
  }, [data, isFetching]);

  // If the import is finished, show a success message and reset the import state to switch back to the
  // redistribution table
  useEffect(() => {
    if (!isPending) {
      dispatch(addToast({ message: 'SKU Redistribution import finished' }));
      resetImport();
    }
  }, [dispatch, isPending, resetImport]);

  return (
    <Column $gap="1rem" $alignItems="center">
      {isPending && <SkuRedistributionRunningMessage />}
    </Column>
  );
};

export default RedistributionImportStepFinalized;
